module.exports = __webpack_public_path__ + "static/media/envalopSidebarSelelcted.b2b4a4f7.svg";